import React from 'react';
import { Helmet } from 'react-helmet-async';
import Header from './components/Header';
import Hero from './components/Hero';
import Connectors from './components/Connectors';
import { Sandbox } from './components/Sandbox';
import Features from './components/Features';
import Workflow from './components/Workflow';
import Testimonials from './components/Testimonials';
import Advantages from './components/Advantages';
import Onboarding from './components/Onboarding';
import CTA from './components/CTA';
import Footer from './components/Footer';
import './App.scss';

const App: React.FC = () => {
  return (
    <div className="App">
      <Helmet>
        <title>beheard - Система для подачи, обработки и отслеживания заявок</title>
        <meta name="description" content="beheard - удобная система для офисов, учебных заведений и ЖК. Структурируйте внутренние процессы: автоматизация заявок, контроль исполнения и прозрачная аналитика." />
        <meta name="keywords" content="система заявок, helpdesk, service desk, автоматизация бизнес-процессов, трекинг задач, коммуникационная платформа, портал заявок" />
        <meta property="og:title" content="beheard - Система для подачи, обработки и отслеживания заявок" />
        <meta property="og:description" content="Структурированный контроль внутренних процессов. Забудьте о хаосе в мессенджерах и потерянных задачах." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://beheardkz.com" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="beheard - Система для подачи, обработки и отслеживания заявок" />
        <meta name="twitter:description" content="Структурированный контроль внутренних процессов. Забудьте о хаосе." />
        <link rel="canonical" href="https://beheardkz.com" />
      </Helmet>
      
      <Header />
      <Hero />
      <Connectors />
      <Sandbox />
      <Features />
      <Workflow />
      <Testimonials />
      <Advantages />
      <Onboarding />
      <CTA />
      <Footer />
    </div>
  );
};

export default App;
